import {
    useGetMadinaManifestsBetweenCitiesQuery,
    useCancelMadinaTafweejMutation,
    useUnassignMadinaTafweejMutation,
    useCompleteMadinaTafweejMutation,
    useDownloadMadinaTafweejManifestMutation,
} from "@/services/arrivals/madinah/arrival.madinah";

export const useBetweenCities = ({
    queryParams,
    isBetweenCities,
}) => {

    const { mutate: cancelMutation, isPending: isCancelPending } = useCancelMadinaTafweejMutation();
    const { mutate: unassignMutation, isPending: isUnassignPending } = useUnassignMadinaTafweejMutation();
    const { mutate: completeMutation, isPending: isCompletePending } = useCompleteMadinaTafweejMutation();
    const { mutate: downloadMadinaTafweejManifestMutation, isPending: isDownloadMadinaTafweejManifestPending } = useDownloadMadinaTafweejManifestMutation();

    const { data: manifestsBetweenCitiesRes, isLoading, isFetching } = useGetMadinaManifestsBetweenCitiesQuery(queryParams, isBetweenCities);
    const data = manifestsBetweenCitiesRes?.data?.data || [];
    const meta = manifestsBetweenCitiesRes?.data?.meta || {};
    const loading = isLoading || isFetching;
    const isPending = isCancelPending || isUnassignPending || isCompletePending || isDownloadMadinaTafweejManifestPending;

    return {
        data,
        meta,
        cancelMutation,
        unassignMutation,
        completeMutation,
        downloadMadinaTafweejManifestMutation: downloadMadinaTafweejManifestMutation,
        loading,
        isPending
    }

}